<template>
  <div class="bg-light p-5 rounded"></div>
</template>

<script setup>
</script>
